<template>
  <div>
    <!-- Topbar -->
    <div class="nf-topbar d-none d-md-flex align-items-center justify-content-between px-4 px-lg-5">
      <div class="d-flex align-items-center gap-3">
        <router-link
          v-for="(link, i) in dropdown.items"
          :key="i"
          :to="link.to"
          class="nf-topbar-link"
        >
          {{ link.label }}
        </router-link>
      </div>
      <div class="d-flex align-items-center gap-4">
        <a :href="'mailto:' + email" class="nf-topbar-contact">
          <i class="fa fa-envelope me-1 opacity-75"></i>{{ email }}
        </a>
        <a :href="'tel:' + phone.replace(/\s+/g,'')" class="nf-topbar-contact">
          <i class="fa fa-phone-alt me-1 opacity-75"></i>{{ phone }}
        </a>
      </div>
    </div>

    <!-- Navbar -->
    <nav
      class="navbar navbar-expand-lg bg-white navbar-light sticky-top px-3 px-lg-5 py-2"
      :class="{ scrolled: isScrolled }"
    >
      <router-link to="/" class="navbar-brand d-flex align-items-center gap-2">
        <img src="@/assets/nexus logo.jpg" alt="Nexus Logo" style="height:38px;border-radius:6px;" />
        <span class="nf-brand-name d-none d-sm-inline">Nexus Focus Consultancy</span>
      </router-link>

      <!-- Mobile toggle -->
      <button class="navbar-toggler border-0" type="button" @click="toggleDrawer">
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Desktop nav -->
      <div class="collapse navbar-collapse d-none d-lg-flex" id="navbarCollapse">
        <div class="navbar-nav ms-auto py-0 d-flex align-items-center gap-1">
          <router-link
            v-for="(item, i) in navItems"
            :key="i"
            class="nav-item nav-link"
            :to="item.to"
            exact-active-class="active"
          >{{ item.label }}</router-link>

          <!-- Dropdown -->
          <div
            class="nav-item dropdown position-relative"
            @mouseenter="showDropdown = true"
            @mouseleave="showDropdown = false"
          >
            <a href="#" class="nav-link dropdown-toggle pe-none" @click.prevent>
              {{ dropdown.label }}
            </a>
            <transition name="nf-dropdown">
              <div v-if="showDropdown" class="dropdown-menu show" style="min-width:200px;">
                <router-link
                  v-for="(item, i) in dropdown.items"
                  :key="i"
                  class="dropdown-item"
                  :to="item.to"
                >{{ item.label }}</router-link>
              </div>
            </transition>
          </div>

          <!-- CTA button -->
          <router-link to="/quote" class="btn btn-primary btn-sm ms-3 px-4 rounded-pill">
            Get a Quote
          </router-link>
        </div>
      </div>
    </nav>

    <!-- Drawer overlay -->
    <transition name="nf-fade">
      <div v-if="isDrawerOpen" class="nf-overlay" @click="toggleDrawer"></div>
    </transition>

    <!-- Mobile Drawer -->
    <transition name="nf-slide">
      <div v-if="isDrawerOpen" class="nf-drawer">
        <div class="nf-drawer-head d-flex justify-content-between align-items-center">
          <img src="@/assets/nexus logo.jpg" alt="Logo" style="height:32px;border-radius:4px;" />
          <button class="btn-close btn-close-white" @click="toggleDrawer"></button>
        </div>
        <div class="nf-drawer-body">
          <router-link
            v-for="(item, i) in navItems"
            :key="i"
            class="nf-drawer-link"
            :to="item.to"
            @click="toggleDrawer"
          >{{ item.label }}</router-link>

          <div class="nf-drawer-section-label">Explore</div>
          <router-link
            v-for="(item, i) in dropdown.items"
            :key="'d'+i"
            class="nf-drawer-link sub"
            :to="item.to"
            @click="toggleDrawer"
          >{{ item.label }}</router-link>

          <router-link to="/quote" class="btn btn-primary w-100 mt-4 rounded-pill" @click="toggleDrawer">
            Get a Quote
          </router-link>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'HeaderComponent',
  props: {
    email: { type: String, default: 'enquiries@nexusfocusconsultancy.com' },
    phone: { type: String, default: '+254 729 768 692' },
  },
  data() {
    return {
      isDrawerOpen: false,
      showDropdown: false,
      isScrolled: false,
      navItems: [
        { label: 'Home',    to: '/'        },
        { label: 'About',   to: '/about'   },
        { label: 'Services', to: '/services' },
        { label: 'Contact', to: '/contact' },
      ],
      dropdown: {
        label: 'Explore',
        items: [
          { label: 'Our Projects',    to: '/projects' },
          { label: 'Blog Posts',      to: '/blog'     },
          { label: 'Request Service', to: '/quote'    },
        ],
      },
    };
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, { passive: true });
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    onScroll() {
      this.isScrolled = window.scrollY > 40;
    },
    toggleDrawer() {
      this.isDrawerOpen = !this.isDrawerOpen;
    },
  },
};
</script>

<style scoped>
/* ── Topbar ── */
.nf-topbar {
  background: var(--nf-green-dark, #0e4530);
  min-height: 40px;
  font-size: 0.82rem;
}
.nf-topbar-link {
  color: rgba(255,255,255,0.7);
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
  padding: 0 8px;
  border-right: 1px solid rgba(255,255,255,0.15);
}
.nf-topbar-link:last-child { border-right: none; }
.nf-topbar-link:hover { color: #fff; }
.nf-topbar-contact {
  color: rgba(255,255,255,0.85);
  text-decoration: none;
  font-size: 0.82rem;
  transition: color 0.2s;
}
.nf-topbar-contact:hover { color: var(--nf-gold, #c9992d); }

/* ── Brand name ── */
.nf-brand-name {
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: var(--nf-green, #1a6b4a);
  letter-spacing: -0.01em;
}

/* ── Navbar transitions ── */
.navbar.scrolled {
  box-shadow: 0 4px 24px rgba(0,0,0,0.10) !important;
}

/* ── Dropdown animation ── */
.nf-dropdown-enter-active,
.nf-dropdown-leave-active { transition: opacity 0.2s ease, transform 0.2s ease; }
.nf-dropdown-enter-from,
.nf-dropdown-leave-to    { opacity: 0; transform: translateY(-8px); }

/* ── Overlay ── */
.nf-overlay {
  position: fixed; inset: 0;
  background: rgba(0,0,0,0.45);
  z-index: 1040;
  backdrop-filter: blur(2px);
}
.nf-fade-enter-active, .nf-fade-leave-active { transition: opacity 0.3s; }
.nf-fade-enter-from, .nf-fade-leave-to { opacity: 0; }

/* ── Drawer ── */
.nf-drawer {
  position: fixed;
  top: 0; right: 0;
  width: min(340px, 85vw);
  height: 100vh;
  background: #fff;
  z-index: 1050;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  box-shadow: -8px 0 40px rgba(0,0,0,0.15);
}
.nf-slide-enter-active, .nf-slide-leave-active { transition: transform 0.35s ease; }
.nf-slide-enter-from, .nf-slide-leave-to { transform: translateX(100%); }

.nf-drawer-head {
  background: var(--nf-green-dark, #0e4530);
  padding: 1rem 1.25rem;
}
.nf-drawer-body {
  padding: 1.25rem 1.5rem 2rem;
  display: flex;
  flex-direction: column;
}
.nf-drawer-link {
  display: block;
  padding: 0.7rem 0;
  font-weight: 600;
  font-size: 1rem;
  color: var(--nf-charcoal, #2c3e50);
  text-decoration: none;
  border-bottom: 1px solid rgba(0,0,0,0.06);
  transition: color 0.2s;
}
.nf-drawer-link.sub {
  font-size: 0.9rem;
  font-weight: 500;
  color: #6b7b8a;
  padding-left: 0.75rem;
}
.nf-drawer-link:hover, .nf-drawer-link.sub:hover { color: var(--nf-green, #1a6b4a); }
.nf-drawer-section-label {
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--nf-gold, #c9992d);
  margin: 1.2rem 0 0.4rem;
}
</style>
